module.exports = __webpack_public_path__ + "static/img/增值税管理云7.00fdc317.png";